import { useDispatch, useSelector } from "react-redux";
import FilterHeader from "../../components/FilterHeader";
import FilterSelection from "../../../../experiments/BubbleJourney/components/FilterSelection";
import { customSortOrder } from "../../../../lib";
import {
  AnalyticsTypeMap,
  LOCATION_MAP,
  SelectionDescriptionMap,
  SORT_BY_VIEW,
  SortByDropdownOptions,
  SortByNameMap,
} from "../../../../constants";
import styles from "./SortBy.module.scss";
import FilterSelectionLoadingSkeleton from "../../../../components/FilterSelectionLoadingSkeleton";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import { FILTERS, SELECT } from "../../../../constants/analytics";

const SortBy = () => {
  const dispatch = useDispatch();
  const { ppConfig, prefetchedFilters } = useSelector((state) => state.filter);
  const { sortBy } = prefetchedFilters;
  const { activeView } = useSelector((state) => state.view);
  const sortedFilterArray = customSortOrder(
    ppConfig.orderBy,
    SortByDropdownOptions
  );

  function handleSortBySelection(sort) {
    dispatch({
      type: "TOGGLE_FILTER_SELECTION",
      payload: {
        filter: SORT_BY_VIEW,
        type: sort.type,
      },
    });
    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get(SORT_BY_VIEW),
      action: SELECT,
      value: SortByNameMap.get(sort.type),
      location: LOCATION_MAP.get(activeView) || "",
    });
    dispatch({
      type: "FINALISE_FILTER_SELECTIONS",
    });
    dispatch({
      type: "SET_ACTIVE_FILTER_VIEW",
      payload: "",
    });
  }

  return (
    <>
      <FilterHeader />
      <ul className={styles.sortBySelections}>
        {sortedFilterArray.length
          ? sortedFilterArray.map((sort) => (
              <FilterSelection
                key={sort.type}
                onClick={() => handleSortBySelection(sort)}
                checked={sortBy === sort.type}
                showCheckbox={false}
                label={SortByNameMap.get(sort.type)}
              >
                <FilterSelectionLoadingSkeleton
                  skeletonKey={sort.type}
                  textBlocks={2}
                />
                <div>
                  <h4>{SortByNameMap.get(sort.type)}</h4>
                  <p>{SelectionDescriptionMap.get(sort.type)}</p>
                </div>
              </FilterSelection>
            ))
          : null}
      </ul>
    </>
  );
};

export default SortBy;
